import styled from 'styled-components'

const Description = styled.div`
  padding: 16px;
  text-align: justify;
  white-space: normal;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export { Description, ButtonWrapper }
